export const defaultInternalTelemetryData = {
  environmentVersion: "prod",
  chatWidgetLocaleLCID: "1033",
  channelId: "lcw2.0"
};